// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wY-Tn","value":"styles_value__CffxE","expandButton":"styles_expandButton__15esS","icon":"styles_icon__5EUr8"};